import { TransformShaker as e, Shaker as n, Sequence as r, KinematicRotationTween as s, KinematicTween as t, TweenValue as m, Tween as a } from "./components.js";
import { shakerParser as o, sequenceParser as S, tweenParser as c } from "./parser.js";
import { KinematicTweenSystem as i, KinematicRotationTweenSystem as p, TweenSystem as y, SequenceSystem as T, ShakerApplySystem as h, ShakerRestoreSystem as k, ShakerCleanupSystem as w, TransformShakerApplySystem as u, TransformShakerRestoreSystem as f, TransformShakerCleanupSystem as l } from "./systems.js";
const R = {
  systems: [
    i,
    p,
    y,
    T,
    h,
    k,
    w,
    u,
    f,
    l
  ],
  components: {
    Tween: a,
    TweenValue: m,
    KinematicTween: t,
    KinematicRotationTween: s,
    Sequence: r,
    Shaker: n,
    TransformShaker: e
  },
  recipes: [
    { name: "tween", components: [] },
    { name: "sequence", components: [] },
    { name: "shaker", components: [] }
  ],
  config: {
    parsers: {
      tween: c,
      sequence: S,
      shaker: o
    }
  }
};
export {
  R as TweenPlugin
};
//# sourceMappingURL=plugin.js.map
